<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-30 
-->
<template>
  <div class="main-container">
    <page-header>{{'联系客服' | dealLanguage('Contact Us')}}</page-header>
    <div class="contact-wrapper">
      <div class="top-tip" v-if="language == 'zh'">这里有一段文案内容，大概是扫码添加客服咨询相关问题这里有一段文案内容，大概是扫码添加客服咨询相关问题 具体文案待提供</div>
      <div class="top-tip" v-if="language == 'en'">Here is a text content</div>
      <img src="https://static-cdn.vbdata.cn/vbdata-ssr/pic/vcbeat/newshangwu.jpg" class="code-img" />
    </div>
  </div>
</template>
<script>
import PageHeader from '@/components/mobile/pageHeader.vue'
import { mapState } from 'vuex'
import filter from 'js/filter'
export default {
  metaInfo(){
    return {
      title: filter.dealLanguage('联系客服', 'Contact Us'),
    }
  },
  inject: ['wxShare'],
  components: {
    PageHeader,
  },
  created() {},
  mounted() {
    this.wxShare({
      title: filter.dealLanguage('联系客服-2025VBEF大会', 'Contact Us-2025VBEF Conference'),
      linkurl: this.vbef_path + '/contactUs',
      img: this.static_img_url + 'pic/share-img.jpg',
    })
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      static_img_url: (state) => state.static_img_url,
      vbef_path: (state) => state.vbef_path,
      language: (state) => state.language,
    }),
  },
  methods: {},
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-m.styl'
.contact-wrapper
  padding 0.3rem 0.4rem 0.6rem
  .top-tip
    font-size 0.26rem
    color #3D3D3D
    line-height 0.42rem
    text-align justify
    span
      color #FF8824
  .code-img
    margin 0.6rem auto
    width 2.34rem
    height 2.34rem
    display block
</style>